import { useApplicationModals } from "app/common/hooks";
import MainLayout from "app/layouts/main";
import { Formik, getIn } from "formik";
import * as Yup from "yup";
import { InputLabel } from "app/components/atoms/form";
import { useCreateForm } from "app/integration/common/hooks";
import api from "app/integration/api";
import { useCollector } from "app/integration/common/hooks";
import { FormHeader } from "app/components/atoms/layout";
import { useCallback } from "react";
import Table from "app/components/atoms/table";
import { Button, IconButton } from "app/components/atoms/button";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppModals from "app/modals";
import clsx from "clsx";
import style from "style/height.module.css";
import { TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import { ErrorMessage } from "app/components/atoms/form";
import { Badge } from "app/components/atoms/badge";
import { useToast } from "app/components/atoms/toast/toast";


const breadcrumbItems = [
    { label: "Stock Opname", href: "/stock-opname" },
    { label: "Tambah Stock Opname", href: "#" },
];

function CreateStockOpname() {
    let isError = false;
    const navigate = useNavigate();
    const formStockOpname = useRef(null);
    const { showToast } = useToast();

    const { openModal, setPayloads } =
        useApplicationModals();

    const handleSuccess = () => {
        navigate("/stock-opname");
    };

    const [productVariants] = useCollector({ modelName: "productVariant" });
    const [qrCode, setQrCode] = useState("");
    const scanBarcodeInputRef = useRef(null);

    const makeid = (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    const { initialValues, validationSchema, onSubmit } = useCreateForm({
        initialValues: {
            items: []
        },
        validationSchema: Yup.object().shape({
            items: Yup.array().of(Yup.object().shape({
                product_variant_id: Yup.number().required("Variant harus diisi"),
                product_code: Yup.array().of(Yup.object().shape({
                    qr_code: Yup.string().required("Barcode harus diisi"),
                })),
                qty: Yup.number().required("Jumlah harus diisi"),
            })).required("Item harus diisi. Silahkan tambahkan item melalui input barcode.").min(1, "Item harus diisi"),
        }),
        onSubmit: async (values) => {
            try {
                for (let index = 0; index < values?.items?.length; index++) {
                    const item = values?.items[index];

                    const arrayProductCode = item?.product_code?.map((item) => item?.qr_code);

                    await api.stockOpname.store(
                        makeid(10),
                        arrayProductCode,
                        item?.product_variant?.product_detail?.name,
                        item?.product_variant_id,
                        null,
                        item?.qty,
                        new Date(),
                        "stock opname " + new Date().toLocaleDateString(),
                        "approved"
                    );
                }
                isError = false;
            } catch (error) {
                setPayloads("errorMessage.view", {
                    title: "Add Stock Opname Error",
                    message: error?.response?.data?.message,
                });
                isError = true;
                openModal("errorMessage.view");
            }
        },
        onSuccess: () => {
            if (!isError) {
                handleSuccess();
            }
        },
    });

    const setItemOrder = useCallback(async (value) => {
        try {
            // Get product code directly from backend with specific QR code
            const response = await api.productCode.index({
                qr_code: value?.replace(/"/g, ""),  // Remove all quotes globally
                limit: 1
            });

            const productCode = response.data[0];

            // Check if product code exists and is in warehouse status
            if (!productCode) {
                console.warn(`Product code not found or not in warehouse for QR code: ${value}`);

                setPayloads("errorMessage.view", {
                    title: "Scan Error",
                    message: productCode ?
                        `Product code ${value} is not in warehouse status` :
                        `Product code not found for QR code: ${value}`,
                });
                isError = true;
                openModal("errorMessage.view");
                return null;
            }

            const responseVariant = await api.productVariant.index({
                id: productCode?.product_variant_id,
                limit: 1
            });

            const productVariant = responseVariant.data[0];
            // Check if product variant exists
            if (!productVariant) {
                console.warn(`Product variant not found for QR code: ${value}`);

                setPayloads("errorMessage.view", {
                    title: "Tambah Customer Error",
                    message: `Product variant not found for QR code: ${value}`,
                });
                isError = true;
                openModal("errorMessage.view");
                return null;
            }
            productCode.product_variant = productVariant;
            return productCode;
        } catch (err) {
            console.error("Error fetching product code:", err);
            setPayloads("errorMessage.view", {
                title: "API Error",
                message: err?.response?.data?.message || "Error fetching product code",
            });
            isError = true;
            openModal("errorMessage.view");
            return null;
        }
    }, [productVariants, setPayloads, openModal]);  // Add dependencies array

    const handleScanBarcodeChange = async (e, { setFieldValue, values }) => {
        // Immediately refocus the input after any change
        if (scanBarcodeInputRef.current) {
            scanBarcodeInputRef.current.focus();
        }

        if (values?.product_variant_id === null) {
            // Item scanned is not within shopping list
            setPayloads("errorMessage.view", {
                title: "Produk Varian tidak ditemukan",
                message: "Silahkan pilih Produk Varian terlebih dahulu.",
            });
            isError = true;
            openModal("errorMessage.view");
            // Clear both input and qrCode state after processing
            setQrCode("");
            return;
        }

        // Only process when Enter key is pressed
        if (e.key === "Enter" && e.target.value?.trim() !== "") {
            const qrValue = e.target.value.trim();
            setItemOrder(qrValue).then(async (itemOrder) => {
                var isFound = false;

                if (itemOrder) {
                    const existingItem = values?.items?.find(item => item.product_variant_id === itemOrder.product_variant_id);
                    if (existingItem) {
                        const isQrCodeExists = existingItem.product_code?.find(item => item.qr_code === itemOrder?.qr_code);
                        if (!isQrCodeExists) {
                            existingItem.product_code = [...existingItem.product_code, itemOrder];
                            existingItem.qty += 1;
                        }
                    } else {
                        const newVariant = {
                            product_variant_id: itemOrder.product_variant_id,
                            product_variant: itemOrder.product_variant,
                            product_code: [itemOrder],
                            qty: 1
                        };
                        setFieldValue("items", [...values.items, newVariant]);
                    }
                    setQrCode(qrValue);
                    isFound = true;
                }

                if (!isFound) {
                    // Item scanned is not within shopping list
                    setPayloads("errorMessage.view", {
                        title: "Product tidak ditemukan",
                        message: "Produk tidak ditemukan.",
                    });
                    isError = true;
                    openModal("errorMessage.view");
                }
                // Clear both input and qrCode state after processing
                setQrCode("");
                e.preventDefault(); // Prevent default enter key behavior
            });
        }
        console.log(values);
    };

    const deleteItem = (indexProductVariant, indexProductCode, values, setFieldValue) => {
        const newProductStockOpname = [...values.items];
        const productVariant = newProductStockOpname[indexProductVariant];

        // Remove the specific product code
        productVariant.product_code.splice(indexProductCode, 1);
        productVariant.qty -= 1;

        // If there are no more product codes left, remove the product variant
        if (productVariant.product_code.length === 0) {
            newProductStockOpname.splice(indexProductVariant, 1);
        }

        setFieldValue("items", newProductStockOpname);
    };

    const handleSuccessProductChoose = (product) => {
        if (formStockOpname.current) {
            const values = formStockOpname.current?.values;

            const existingItemIndex = values.items?.findIndex(
                (existingItem) =>
                    existingItem.product_variant_id === product?.product_variant?.id &&
                    existingItem.size_variant_id === product?.variant?.size?.id &&
                    existingItem.color_variant_id === product?.variant?.color?.id
            );

            if (existingItemIndex !== -1) {
                showToast("Barang sudah  ditambahkan.", "warning");
            } else {
                console.log("product success", product);
                // If product doesn't exist, add new item
                formStockOpname.current.setFieldValue("items", [
                    ...values.items,
                    {
                        product_variant_id: product?.product_variant_id,
                        product_variant: product?.product_variant,
                        product_code: [product],
                        qty: 1
                    }
                ]);
                showToast("Anda telah menambahkan produk ke dalam stock opname", "success");
            }
        }
    };

    return (
        <MainLayout
            activeSidebarNavigation="warehouse"
            activeSidebarChild="stock_opname"
            breadcrumbItems={breadcrumbItems}
            pageTitle="Tambah Stock Opname"
            headingButtons={[
                {
                    type: "button",
                    label: "Scan Barcode", // This will be shown as a tooltip
                    onClick: () => {
                        setPayloads("product.scanQrProductCode", { status: "all" });
                        openModal("product.scanQrProductCode");
                    },
                },
            ]}
        >
            <AppModals
                items={["errorMessage.view", "product.scanQrProductCode"]}
                onSuccess={{
                    "errorMessage.view": () => fetch(),
                    "product.scanQrProductCode": (product) => handleSuccessProductChoose(product),
                }}
            />
            <Formik
                {...{ initialValues, validationSchema, onSubmit }}
                enableReinitialize={true}
                innerRef={formStockOpname}
            >
                {({
                    values,
                    errors,
                    status,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                }) => (
                    <form
                        className={clsx(
                            "px-2 overflow-y-auto",
                            style["main-content-height"]
                        )}
                        onSubmit={handleSubmit}
                    >
                        <FormHeader>
                            <div className="">
                                <InputLabel>Scan Barcode Disini</InputLabel>
                                <input data-testid="stock-opname-create-scan-barcode-input"
                                    className="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-gray-900 placeholder-gray-300 shadow-sm focus:border-primary-600 focus:outline-none disabled:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder-gray-500 autofill:dark:bg-gray-800 dark:disabled:bg-gray-800 focus:ring-1 focus:ring-primary-600"
                                    type="text"
                                    name="scan_barcode"
                                    onChange={(e) => {
                                        setQrCode(e.target.value);
                                        handleScanBarcodeChange(e, { setFieldValue, values });
                                    }}
                                    onKeyDown={(e) => {
                                        // Trigger scanning on Enter key
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // Prevent the default form submission
                                            handleScanBarcodeChange(e, { setFieldValue, values });
                                        }
                                    }}
                                    onBlur={(e) => {
                                        handleBlur(e);
                                        // Immediately refocus if blur occurs
                                        if (scanBarcodeInputRef.current) {
                                            scanBarcodeInputRef.current.focus();
                                            scanBarcodeInputRef.current.select();
                                        }
                                    }}
                                    value={qrCode}
                                />
                            </div>
                        </FormHeader>

                        <Table.Container>
                            <Table.Wrapper asIndex={false}>
                                <Table.Header>
                                    <Table.HeaderRow>
                                        <Table.Heading>Product Name</Table.Heading>
                                        <Table.Heading>Warna</Table.Heading>
                                        <Table.Heading>Ukuran</Table.Heading>
                                        <Table.Heading>Jumlah</Table.Heading>
                                        <Table.Heading>Status</Table.Heading>
                                        <Table.Heading>Actions</Table.Heading>
                                    </Table.HeaderRow>
                                </Table.Header>
                                <Table.Body>
                                    {values?.items?.map((stockOpname, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <Table.BodyRow key={key}>
                                                    <Table.Cell>
                                                        <strong>{stockOpname?.product_variant?.product_detail?.name}</strong>
                                                    </Table.Cell>
                                                    <Table.Cell>{stockOpname?.product_variant?.color?.name}</Table.Cell>
                                                    <Table.Cell>{stockOpname?.product_variant?.size?.name}</Table.Cell>
                                                    <Table.Cell>{stockOpname?.qty}</Table.Cell>
                                                    <Table.Cell></Table.Cell>
                                                    <Table.Cell></Table.Cell>
                                                </Table.BodyRow>
                                                {stockOpname?.product_code?.map((productCode, index) => (
                                                    <Table.BodyRow key={index}>
                                                        <Table.Cell></Table.Cell>
                                                        <Table.Cell colSpan={3}>{productCode?.qr_code}</Table.Cell>
                                                        <Table.Cell><Badge
                                                            color={
                                                                productCode?.status == "packing"
                                                                    ? "yellow"
                                                                    : productCode?.status == "delivery"
                                                                        ? "yellow"
                                                                        : productCode?.status == "retur"
                                                                            ? "red"
                                                                            : productCode?.status == "scrap"
                                                                                ? "red"
                                                                                : productCode?.status == "warehouse"
                                                                                    ? "gray"
                                                                                    : "blue"
                                                            }
                                                            size="sm"
                                                        >
                                                            {productCode?.status}
                                                        </Badge></Table.Cell>
                                                        <Table.Cell>
                                                            <div className="flex items-center justify-center gap-2">
                                                                <IconButton testId="stock-opname-create-trash-button"
                                                                    onClick={() => deleteItem(key, index, values, setFieldValue)}
                                                                    icon={TrashIcon}
                                                                    variant="danger"
                                                                />
                                                            </div>
                                                        </Table.Cell>
                                                    </Table.BodyRow>
                                                ))}
                                            </React.Fragment>
                                        );
                                    })}
                                </Table.Body>
                            </Table.Wrapper>
                        </Table.Container>
                        <ErrorMessage>{getIn(errors, "items")}</ErrorMessage>

                        <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
                            <Button testId="stock-opname-create-simpan-button" type="submit" loading={isSubmitting}>Simpan</Button>
                        </div>
                    </form>
                )}
            </Formik>
        </MainLayout>
    );
}

export default CreateStockOpname;
